import React, { useState, useEffect } from "react";
import "../styles/DisclaimerPopup.css";

const DisclaimerPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Check if the user has already agreed in this session
    const agreed = sessionStorage.getItem("disclaimerAgreed");
    if (!agreed) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 5000); // Popup appears after 5 seconds

      return () => clearTimeout(timer);
    }
  }, []);

  const handleAgree = () => {
    setIsOpen(false);
    sessionStorage.setItem("disclaimerAgreed", "true");
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="disclaimer-overlay geist-font fw-lighter">
      <div className="disclaimer-popup">
        <button className="disclaimer-close" onClick={handleClose}>
          &times;
        </button>
        <div className="disclaimer-content">
          <h2 className="disclaimer-title">DISCLAIMER</h2>

          <div className="disclaimer-body">
            <p>
              <span className="disclaimer-note">Note:</span> This website is in the process of being updated. By accessing this website, the viewer confirms that the information including brochures and marketing collateral's on this website are solely for informational purposes only and the viewer has not relied on this information for making any booking/purchase in any project of the Company. Nothing on this website, constitutes advertising, marketing, booking, selling or an offer for sale, or invitation to purchase a unit in any project by the Company. The Company is not liable for any consequence of any action taken by the viewer relying on such material/information on this website.
            </p>
          </div>

          <div className="disclaimer-contact-box">
            <p className="mb-0">
              Please contact our Sales Team at <strong>info@vessella.in</strong> for the updated sales and marketing information and collateral's.
            </p>
          </div>

          <div className="disclaimer-footer">
            <button className="submit-btn geist-font" onClick={handleAgree}>
              I AGREE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
